import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";

import "./Home.scss";
import logo from "./../../img/logos/mfly_white.png";
import hilift from "./../../img/home/hi_lift.jpg";
import advanced from "./../../img/home/advanced.jpg";
import auton from "./../../img/home/auton.jpg";

export default function Home() {
  useEffect(() => {
    AOS.init({
      easing: "ease",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>M-Fly</title>
      </Helmet>
      <div className="Home">
        <div className="bgimg bgimg-team">
          <div className="caption">
            <img
              src={logo}
              alt="M-Fly"
              className="logo"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-duration="2000"
            />
            <h1
              data-aos="fade-up"
              data-aos-delay="800"
              data-aos-anchor=".Home .logo"
              data-aos-duration="2000"
            >
              Welcome aboard.
            </h1>
          </div>
        </div>

        <div className="white-div">
          <h2 className="text-center">Who We Are</h2>
          <p className="description-center">
            M-Fly’s mission is to provide a multi-disciplinary learning experience for students while 
            establishing a tradition of competitiveness and success in the SAE Aero Design and SUAS 
            competitions. Our mission is to provide valuable hands-on learning experiences for Michigan 
            students outside the classroom through engineering practices, teamwork, and professional 
            development opportunities. We also seek to create a safe and inclusive learning environment 
            for students to develop their technical, professional, and interpersonal skills through 
            engagement with complex, real-world engineering challenges.
          </p>
          <div className="stats-container">
            <div className="stat-bubble" data-aos="fade-up" data-aos-delay="100">
              <div className="stat-number">17+</div>
              <div className="stat-label">Years of Flight</div>
            </div>
            <div className="stat-bubble" data-aos="fade-up" data-aos-delay="200">
              <div className="stat-number">80+</div>
              <div className="stat-label">Team Members</div>
            </div>
            <div className="stat-bubble" data-aos="fade-up" data-aos-delay="300">
              <div className="stat-number">3</div>
              <div className="stat-label">Subteams</div>
            </div>
            <div className="stat-bubble" data-aos="fade-up" data-aos-delay="400">
              <div className="stat-number">50+</div>
              <div className="stat-label">Awards Won</div>
            </div>
          </div>        </div>

        <div className="bgimg bgimg-autonomous">
          <div className="caption">
            <span className="border" data-aos="fade-up">
              AUTONOMOUS
            </span>
          </div>
        </div>

        <div className="blue-div">
          <div className="clearfix ox split-left">
            <img
              src={auton}
              alt="Autonomous"
              className="plane-img"
              data-aos="fade-left"
            />
            <p>
              The Autonomous team is currently in its 9th year and participates in
              the SUAS competition. This
              aircraft must autonomously complete a mission of
              flight systems and computer vision challenges, including navigation, obstacle
              avoidance, object detection and classification, and a payload drop. In addition,
              the plane should optimize to minimize weight and size for ease of portability. This past year's
              aircraft placed 18th out of 81 total teams.
            </p>
          </div>
        </div>

        <div className="bgimg bgimg-hilift">
          <div className="caption">
            <span className="border" data-aos="fade-up">
              HI-LIFT
            </span>
          </div>
        </div>

        <div className="white-div">
          <div className="clearfix ox split-left">
            <img
              src={hilift}
              alt="Hi-Lift"
              className="plane-img float-right"
              data-aos="fade-left"
              data-aos-easing="ease"
            />
            <p>
              The Hi-Lift program is the oldest program at M-Fly. For the past 17 years,
              the program has competed in the SAE Aero Design competition, where it specifically
              partakes in the Regular Class competition, where the objective of
              is to design an aircraft that can
              lift as much weight as required while maximizing wingspan. This past year, the M-17
              finished second overall in design report.
            </p>

          </div>
        </div>

        <div className="bgimg bgimg-advanced">
          <div className="caption">
            <span className="border" data-aos="fade-up">
              ADVANCED CLASS
            </span>
          </div>
        </div>

        <div className="blue-div">
          <div className="clearfix split-left">
            <img
              src={advanced}
              alt="Advanced Class"
              className="plane-img float-left"
              data-aos="fade-right"
            />
            <p>
              The Advanced Class program just completed its 10th year on M-Fly and competing
              in the SAE Aero Design Competition. It is a systems-engineering based competition
              where the aircraft must complete a  mission with the delivery and retrieval of a payload
              while staying under an extremely small weight restriction. This past year's aircraft
              was awarded third in design report.
            </p>
          </div>
        </div>

        <div className="bgimg bgimg-all">
          <div className="caption">
            <span className="border">
              <a
                href="mailto:mfly@umich.edu"
                style={{
                  textDecoration: "none",
                  color: "var(--blue)",
                  textTransform: "uppercase",
                }}
              >
                mfly@umich.edu
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
